import type { IOption } from '@shared/form/types';

export const getAvailableTimezones = (timeZoneOptions: IOption[]): string[] =>
  timeZoneOptions.flatMap((timezoneOption) =>
    typeof timezoneOption.value === 'string' ? [timezoneOption.value] : []
  );
